import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./feature/auth/auth";
import deviceReducer from "./feature/device/index";


//persist these variable to local storage
const persistConfig = {
  key: "authenticate",
  storage,
  whitelist: [
    "isLoggedIn",
    "role",
    "userId",
    "username",
    "organisationName",
    "userToken",
    "createdBy",
    "fullName"
  ], // only persist the 'user' slice of state
};
//persist these variable to local storage
const persistDeviceConfig = {
  key: "device",
  storage,
  whitelist: ["listDevices", "deviceAdded", "isDeviceApproved"], // only persist the 'user' slice of state
};


//wrap the object with the provided persistent storage from redux
const persistedReducer = persistReducer(persistConfig, authReducer);

//wrap the object with the provided persistent storage from redux
const persistedDeviceReducer = persistReducer(
  persistDeviceConfig,
  deviceReducer
);

//configure it and export it
export const store = configureStore({
  reducer: {
    authenticate: persistedReducer,
    device: persistedDeviceReducer,
  },
});

export const persistor = persistStore(store);
